const mustBeChecked = (value: string, message?: string) => value.length || (message ?? 'Must be checked');
const noDefaultSelect = (value: string, message?: string) =>
	(value !== '-1' && value !== '') || (message ?? 'No defaults');
const matchesValue = (value: string, matchValue: string, message?: string) =>
	value === matchValue || (message ?? 'Values do not match');

export { mustBeChecked, noDefaultSelect, matchesValue };
